import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=511de6dd&scoped=true&"
import script from "./checkboxControl.js?vue&type=script&lang=js&"
export * from "./checkboxControl.js?vue&type=script&lang=js&"
import style0 from "./checkbox.css?vue&type=style&index=0&id=511de6dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511de6dd",
  null
  
)

export default component.exports